module.exports = __webpack_public_path__ + "img/B803.047bf679.jpg";